export default __webpack_public_path__ + "static/046-e58db1a12c280b9763cd33612dcb4e39.jpg";